// Keep the selected destination visible without rebuilding any page content.
(() => {
  const positionNavigation = (root = document) => {
    root.querySelectorAll('.mv-page-mobile-nav').forEach((nav) => {
      const current = nav.querySelector('[aria-current="page"]');
      if (current && nav.clientWidth) {
        nav.scrollLeft = current.offsetLeft - nav.offsetLeft - (nav.clientWidth - current.offsetWidth) / 2;
      }
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => positionNavigation());
  } else {
    positionNavigation();
  }
  document.addEventListener('shopify:section:load', (event) => positionNavigation(event.target));
})();
